import {
  ArrowRightOutlined,
  AuditOutlined,
  ClearOutlined,
  EditOutlined,
  FileDoneOutlined,
  FileExclamationOutlined,
  FileOutlined,
  FileTextOutlined,
  IdcardOutlined,
  PlusOutlined,
  SaveOutlined,
  SmileOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import { Card as AntCard, Button, Dropdown, Flex, Form, Input, Modal, Space, Spin, Typography, message } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ContractApi } from "src/api";
import { createAdmissionFlow, findByIdAdmissionFlow, updateAdmissionFlow } from "src/api/auth/admission-flow.api";
import { Card, If, Tabs } from "src/components";
import AdmissionFlowStepIcon from "src/components/AdmissionFlowStepIcon/AdmissionFlowStepIcon";
import { Routes } from "src/routes/routing";
import { dictionary, i18n } from "src/utils";
import EditAdmissionFlowStep from "./EditAdmissionFlowStep";
import EditAdmissionFlowVisualSettings from "./EditAdmissionFlowVisualSettings";

const { Text, Title } = Typography;

const EMAIL_BODY_DEFAULT_TEXTS = [
  {
    stepId: 1,
    content: `[{"type":"paragraph","children":[{"text":"Prezado(a) "},{"text":"<NOME_COLABORADOR>","field":false,"bold":true},{"text":","}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Gostaríamos de solicitar gentilmente que nos envie os documentos necessários para completar o seu processo de admissão o mais breve possível."}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Por favor, envie os documentos até a data limite definida, para que possamos dar continuidade ao seu processo de admissão sem nenhum atraso."}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Atenciosamente,"}]},{"type":"paragraph","children":[{"text":"<NOME_EMPRESA>","field":false,"bold":true}]}]`,
  },
  {
    stepId: 2,
    content: `[{"type":"paragraph","children":[{"text":"Prezado(a) "},{"text":"<NOME_COLABORADOR>","field":false,"bold":true},{"text":","}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Gostaríamos de informar que o seu contrato de trabalho está disponível para download."}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Para acessar o contrato, por favor, clique no botão abaixo:"}]}]`,
  },
  {
    stepId: 3,
    content: `[{"type":"paragraph","children":[{"text":"Prezado(a) "},{"text":"<NOME_COLABORADOR>","field":false,"bold":true},{"text":","}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"É com grande prazer que damos as boas-vindas à "},{"text":"<NOME_EMPRESA>","field":false,"bold":true},{"text":"! Estamos muito felizes em tê-lo(a) conosco."}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"A sua admissão foi concluída com sucesso, e estamos ansiosos para começar esta jornada juntos. Acreditamos que suas habilidades e experiências serão uma adição valiosa ao nosso time."}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Para ajudá-lo(a) a se integrar rapidamente, estamos preparando todas as informações e recursos necessários para o seu primeiro dia. Se houver algo específico que você gostaria de saber ou se precisar de qualquer assistência adicional, não hesite em entrar em contato conosco."}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Mais uma vez, seja muito bem-vindo(a) à "},{"text":"<NOME_EMPRESA>","field":false,"bold":true},{"text":". Estamos empolgados com o que o futuro reserva para nós!"}]}]`,
  },
  {
    stepId: 4,
    content: `[{"type":"paragraph","children":[{"text":"Prezado(a) "},{"text":"<NOME_COLABORADOR>","field":false,"bold":true},{"text":","}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Estamos muito felizes em formalizar a proposta para a sua entrada no time "},{"text":"<NOME_EMPRESA>","field":false,"bold":true},{"text":"!"}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Segue abaixo o resumo da proposta:"}]},{"type":"paragraph","children":[{"text":"1. Cargo: "},{"text":"<CARGO>","field":false,"bold":true}]},{"type":"paragraph","children":[{"text":"2. Carga horária: "},{"text":"<CARGA_HORARIA>","field":false,"bold":true}]},{"type":"paragraph","children":[{"text":"3. Remuneração: "},{"text":"<REMUNERACAO>","field":false,"bold":true}]},{"type":"paragraph","children":[{"text":"4. Benefícios: "},{"text":"<BENEFICIOS>","field":false,"bold":true}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Pedimos que confirme seu aceite clicando no botão no final desse e-mail."}]},{"type":"paragraph","children":[{"text":"Caso tenha dúvidas ou precise de algum esclarecimento, estamos à disposição."}]},{"type":"paragraph","children":[{"text":"Estamos ansiosos para dar início a essa parceria!"}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Atenciosamente,"}]},{"type":"paragraph","children":[{"text":"<NOME_EMPRESA>","field":false,"bold":true}]}]`,
  },
  {
    stepId: 5,
    content: `[{"type":"paragraph","children":[{"text":"Prezado(a) "},{"text":"<NOME_COLABORADOR>","field":false,"bold":true},{"text":","}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Para darmos continuidade ao processo de sua admissão, é necessário que você realize o exame admissional. Seguem as informações:"}]},{"type":"paragraph","children":[{"text":"1. Local:"}]},{"type":"paragraph","children":[{"text":"2. Endereço:"}]},{"type":"paragraph","children":[{"text":"3. Horário de funcionamento:"}]},{"type":"paragraph","children":[{"text":"4. Contato da clínica:"}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Solicitamos que agende e realize o exame no local indicado. Após a realização do exame, por favor, "},{"text":"envie os laudos anexados clicando no botão ao final deste e-mail","bold":true},{"text":". Se tiver qualquer dúvida ou precisar de assistência para agendar o exame, estamos à disposição para ajudar."}]},{"type":"paragraph","children":[{"text":"Estamos ansiosos para tê-lo(a) oficialmente em nosso time!"}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Atenciosamente,"}]},{"type":"paragraph","children":[{"text":"<NOME_EMPRESA>","field":false,"bold":true}]}]`,
  },
  {
    stepId: 6,
    content: `[{"type":"paragraph","children":[{"text":"Prezado(a) "},{"text":"<NOME_COLABORADOR>","field":false,"bold":true},{"text":","}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Estamos muito felizes com a sua integração ao time da "},{"text":"<NOME_EMPRESA>","field":false,"bold":true},{"text":"!"}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Para formalizar o recebimento dos equipamentos que serão disponibilizados para o desempenho das suas atividades, solicitamos que revise e assine o Termo de Responsabilidade "},{"text":"clicando no botão abaixo","field":false,"bold":true},{"text":"."}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Este documento contém informações importantes sobre as condições de uso e os cuidados necessários com os itens fornecidos pela empresa."}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Se tiver qualquer dúvida sobre o conteúdo do termo ou precisar de suporte durante o processo, não hesite em nos contactar. Estamos à disposição para ajudar!"}]},{"type":"paragraph","children":[{"text":""}]},{"type":"paragraph","children":[{"text":"Atenciosamente,"}]},{"type":"paragraph","children":[{"text":"<NOME_EMPRESA>","field":false,"bold":true}]}]`,
  },
];

const initialAdmissionFlowStepData: AdmissionFlowStepPayload = {
  stepId: 0,
  index: -1,
  emailSubject: "",
  emailBody: JSON.stringify([
    {
      type: "paragraph",
      children: [{ text: "" }],
    },
  ]),
  pagePhrase: "",
  pageDescription: "",
};

export default function AdmissionFlowCreateUpdate() {
  const navigate = useNavigate();

  const params = useParams();

  const [admissionFlowId, setAdmissionFlowId] = useState("");

  const [currentTab, setCurrentTab] = useState(1);

  function validateSteps(steps: AdmissionFlowStepPayload[]): boolean {
    for (const step of steps) {
      const requiredFields: string[] = [];

      if (step.stepId === 7 && step.type === 3) {
        requiredFields.push("fileName");
      }

      if (step.stepId !== 3 && step.type !== 2) {
        requiredFields.push("pagePhrase");
        requiredFields.push("pageDescription");
      }

      if ([2, 4, 6].includes(step.stepId) || (step.stepId === 7 && step.type === 1)) {
        requiredFields.push("documentId");
      }

      const emptyFields = requiredFields.filter(
        (field) =>
          step[field as keyof typeof step] === null ||
          step[field as keyof typeof step] === undefined ||
          step[field as keyof typeof step] === "",
      );

      if (emptyFields.length > 0) {
        Modal.warning({
          title: i18n(dictionary.requiredNotFilledStep, {
            step: step.stepName ?? i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.others.titles[step.stepId]),
          }),
          content: i18n(dictionary.fillRequired, {
            emptyFields: emptyFields
              .map((field) => {
                switch (field) {
                  case "documentId":
                    return i18n(
                      dictionary.pages.admissionFlowCreate.tabs.t1.step.fields.document.select[
                        step.stepId as StepWithDocumentAndValidation
                      ],
                    );
                  case "fileName":
                    return i18n(dictionary.pages.admissionFlowCreate.tabs.t1.step.fields.fileName);
                  case "pagePhrase":
                    return i18n(dictionary.pages.admissionFlowCreate.tabs.t1.step.fields.phrase.label);
                  case "pageDescription":
                    return i18n(dictionary.pages.admissionFlowCreate.tabs.t1.step.fields.description.label);
                  default:
                    return field;
                }
              })
              .join(", "),
          }),
        });

        return false;
      }
    }

    return true;
  }

  // Opções do menu
  const [items, setItems] = useState([
    {
      key: "1",
      label: i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.others.titles[1]),
      onClick: () => createStep(1),
      disabled: false,
      icon: <IdcardOutlined />,
    },
    {
      key: "2",
      label: i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.others.titles[2]),
      onClick: () => createStep(2),
      disabled: false,
      icon: <AuditOutlined />,
    },
    {
      key: "3",
      label: i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.others.titles[3]),
      onClick: () => createStep(3),
      disabled: false,
      icon: <SmileOutlined />,
    },
    {
      key: "4",
      label: i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.others.titles[4]),
      onClick: () => createStep(4),
      disabled: false,
      icon: <FileTextOutlined />,
    },
    {
      key: "5",
      label: i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.others.titles[5]),
      onClick: () => createStep(5),
      disabled: false,
      icon: <FileDoneOutlined />,
    },
    {
      key: "6",
      label: i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.others.titles[6]),
      onClick: () => createStep(6),
      disabled: false,
      icon: <FileExclamationOutlined />,
    },
    {
      key: "7",
      label: "Passo livre",
      onClick: () => createStep(7),
      disabled: false,
      icon: <FileOutlined />,
    },
  ]);

  // Nome do fluxo
  const [flowName, setFlowName] = useState("");

  // Passos do fluxo
  const [steps, setSteps] = useState<AdmissionFlowStepPayload[]>([]);

  // Configurações visuais do fluxo
  const [loadingLogo, setLoadingLogo] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>();
  const [primaryColor, setPrimaryColor] = useState<string>("#884EA6");
  const [secondaryColor, setSecondaryColor] = useState<string>("#66C790");

  // Configurações dos passos do fluxo
  const [selectedStep, setSelectedStep] = useState<AdmissionFlowStepPayload>(initialAdmissionFlowStepData);

  // Tela de edição dos passos do fluxo
  const [editStep, setEditStep] = useState(false);
  // Tela de edição das configurações visuais do fluxo
  const [editVisualSettings, setEditVisualSettings] = useState(false);

  // Controla carregamento do botão de ação (criação e atualização do fluxo)
  const [loadingAction, setLoadingAction] = useState(false);

  // Controla carregamento dos dados quando for edição de fluxo de admissão
  const [loading, setLoading] = useState(false);

  // Documentos
  const [documents, setDocuments] = useState<Contract[]>([]);

  /**
   * Cria o card do passo e desabilita a opção já utilizada
   * @param { Step } step Identificador único do passo
   */
  function createStep(step: Step) {
    setSteps((prevSteps) => {
      const newStep = {
        stepId: step,
        index: prevSteps.length,
        emailSubject: i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.others.titles[step]),
        emailBody:
          EMAIL_BODY_DEFAULT_TEXTS.find(({ stepId }) => stepId === step)?.content ||
          JSON.stringify([
            {
              type: "paragraph",
              children: [{ text: "" }],
            },
          ]),
        pagePhrase:
          step !== 3 ? i18n(dictionary.pages.admissionFlowCreate.tabs.t1.step.fields.phrase.defaultValue) : "",
        pageDescription:
          step !== 3 ? i18n(dictionary.pages.admissionFlowCreate.tabs.t1.step.fields.description.defaultValue) : "",
        validationType: [2, 4, 6].includes(step) ? 1 : undefined,
        stepName: step === 7 ? i18n(dictionary.label.free) : undefined,
        type: step === 7 ? 1 : undefined,
        new: true,
      };

      // abre o componente editor sempre que uma nova etapa é adicionada pra evitar que o usuário acabe criando várias
      // etapas sem verificar que existem campos obrigatórios a serem preenchidos
      setSelectedStep(newStep);

      return [...prevSteps, newStep];
    });

    if (step !== 7)
      // Atualiza o menu do botão de adição de passo;
      setItems((prevItems) => {
        const targetItemIndex = prevItems.findIndex(({ key }) => Number(key) === step);
        prevItems[targetItemIndex].disabled = true;
        return [...prevItems];
      });
  }

  /**
   * Limpa o array de passos e habilita todas as opções;
   */
  function clearSteps() {
    setSteps([]);
    setSelectedStep(initialAdmissionFlowStepData);
    setItems((prevItems) => prevItems.map((item) => ({ ...item, disabled: false })));
    setImageUrl(undefined);
    setPrimaryColor("#884EA6");
    setSecondaryColor("#66C790");
    setFlowName("");
    setLoadingLogo(false);
  }

  async function create() {
    message.destroy();
    setLoadingAction(true);

    const response = await createAdmissionFlow({
      name: flowName,
      logo: imageUrl || null,
      primaryColor,
      secondaryColor,
      flowSteps: steps,
    });
    if (response) {
      message.success(i18n(dictionary.pages.admissionFlowCreate.tabs.t1.notifications.create.success));
      navigate(Routes.ADMISSION_FLOW);
    } else {
      message.error(i18n(dictionary.pages.admissionFlowCreate.tabs.t1.notifications.create.error));
    }
    setLoadingAction(false);
  }

  async function update() {
    message.destroy();
    setLoadingAction(true);
    const response = await updateAdmissionFlow(admissionFlowId, {
      name: flowName,
      logo: imageUrl || null,
      primaryColor,
      secondaryColor,
      flowSteps: steps,
    });
    if (response) {
      message.success(i18n(dictionary.pages.admissionFlowCreate.tabs.t1.notifications.update.success));
    } else {
      message.error(i18n(dictionary.pages.admissionFlowCreate.tabs.t1.notifications.update.error));
    }
    setLoadingAction(false);
  }

  async function getAdmissionFlowById() {
    if (params && params.id) {
      setAdmissionFlowId(params.id);
      const data = await findByIdAdmissionFlow(params.id);
      if (data) {
        setImageUrl(data.logo ?? "");
        setPrimaryColor(data.primaryColor);
        setSecondaryColor(data.secondaryColor);
        setFlowName(data.name);
        setSteps(data.flowSteps);
        // Atualiza o menu do botão de adição de passo;
        for (const element of data.flowSteps) {
          if (element.stepId !== 7)
            setItems((prevItems) => {
              const targetItemIndex = prevItems.findIndex(({ key }) => Number(key) === element.stepId);
              prevItems[targetItemIndex].disabled = true;
              return [...prevItems];
            });
        }
      }
    }
  }

  // Obtém todos os documentos cadastrados pela empresa;
  async function getDocuments() {
    const response = await ContractApi.fetch();
    setDocuments(response);
  }

  async function getData() {
    setLoading(true);
    await getDocuments();
    await getAdmissionFlowById();
    setLoading(false);
  }

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (selectedStep.stepId > 0) setEditStep(true);
  }, [selectedStep]);

  return (
    <>
      <Tabs
        data={[
          {
            index: 1,
            title: i18n(dictionary.pages.admissionFlowCreate.tabs.t1.titles[!!admissionFlowId ? "edit" : "new"]),
          },
        ]}
        setCurrentTab={setCurrentTab}
      />
      <Spin spinning={loading}>
        <If condition={currentTab === 1}>
          {/* Configurações visuais do fluxo */}
          <EditAdmissionFlowVisualSettings
            open={editVisualSettings}
            close={() => setEditVisualSettings(false)}
            loadingLogo={loadingLogo}
            setLoadingLogo={setLoadingLogo}
            imageUrl={imageUrl}
            setImageUrl={setImageUrl}
            primaryColor={primaryColor}
            setPrimaryColor={setPrimaryColor}
            secondaryColor={secondaryColor}
            setSecondaryColor={setSecondaryColor}
          />
          {/* Configurações dos passos do fluxo */}
          <EditAdmissionFlowStep
            open={editStep}
            close={() => {
              setSelectedStep(initialAdmissionFlowStepData);
              setEditStep(false);
            }}
            data={selectedStep}
            setData={setSelectedStep}
            setSteps={setSteps}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
            imageUrl={imageUrl}
            documents={documents}
            setDocuments={setDocuments}
          />
          <Card>
            <Flex
              style={{ width: "100%" }}
              vertical
            >
              <Form
                layout="vertical"
                style={{ marginBottom: 5 }}
              >
                <Form.Item
                  label="Nome do fluxo"
                  required
                >
                  <Input
                    maxLength={100}
                    onChange={({ target }) => setFlowName(target.value)}
                    value={flowName}
                  />
                </Form.Item>
              </Form>
              <Flex
                wrap
                align="center"
                gap={10}
                style={{ marginBottom: 8 }}
              >
                <AntCard
                  title={
                    <Title
                      style={{ margin: 0, color: "#884ea6", textAlign: "center", width: "100%" }}
                      level={5}
                    >
                      <ToolOutlined />
                      &nbsp;
                      {i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.settings.title)}
                    </Title>
                  }
                >
                  <Flex
                    style={{ width: "100%" }}
                    justify="center"
                  >
                    <Button
                      icon={<EditOutlined style={{ color: "#884ea6" }} />}
                      onClick={() => setEditVisualSettings(true)}
                    >
                      {i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.settings.editButton)}
                    </Button>
                  </Flex>
                </AntCard>
                {steps.map((element, index) => (
                  <>
                    <ArrowRightOutlined style={{ color: "#884ea6" }} />
                    <AntCard
                      title={
                        <Title
                          style={{ margin: 0, color: "#884ea6", textAlign: "center", width: "100%" }}
                          level={5}
                        >
                          <AdmissionFlowStepIcon stepId={element.stepId} />
                          &nbsp;
                          {element.stepName ??
                            i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.others.titles[element.stepId])}
                        </Title>
                      }
                      key={index}
                    >
                      <Flex
                        style={{ width: "100%" }}
                        align="center"
                        justify="center"
                      >
                        <Space
                          direction="vertical"
                          align="center"
                        >
                          <Text
                            style={{ cursor: "pointer", color: "#884ea6", textDecoration: "underline" }}
                            onClick={() => {
                              setSelectedStep(element);
                            }}
                          >
                            {i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.others.content)}
                          </Text>
                          <Text
                            style={{ cursor: "pointer", color: "red", textDecoration: "underline" }}
                            onClick={() => {
                              const newSteps = [...steps];
                              newSteps.splice(index, 1);
                              setSteps(
                                newSteps.map((step, index) => {
                                  return { ...step, index };
                                }),
                              );
                              setItems((prevItems) => {
                                const targetItemIndex = prevItems.findIndex(
                                  ({ key }) => Number(key) === element.stepId,
                                );
                                prevItems[targetItemIndex].disabled = false;
                                return [...prevItems];
                              });
                            }}
                          >
                            {i18n(dictionary.action.remove)}
                          </Text>
                        </Space>
                      </Flex>
                    </AntCard>
                  </>
                ))}
                {!items.every(({ disabled }) => disabled) && (
                  <>
                    <ArrowRightOutlined style={{ color: "#884ea6" }} />
                    <Flex
                      vertical
                      align="center"
                      justify="center"
                      gap={3}
                    >
                      <Dropdown menu={{ items }}>
                        <Button icon={<PlusOutlined style={{ color: "#884ea6" }} />}>
                          {i18n(dictionary.pages.admissionFlowCreate.tabs.t1.cards.newStep)}
                        </Button>
                      </Dropdown>
                    </Flex>
                  </>
                )}
              </Flex>
            </Flex>
          </Card>
          <Flex
            style={{ marginTop: 20 }}
            gap={10}
          >
            <Button
              icon={<SaveOutlined />}
              type="primary"
              onClick={() => {
                const validSteps = validateSteps(steps);
                if (validSteps) {
                  !!admissionFlowId ? update() : create();
                }
              }}
              loading={loadingAction}
              disabled={!flowName.length || !steps.length}
            >
              {i18n(dictionary.pages.admissionFlowCreate.tabs.t1.buttons[!!admissionFlowId ? "edit" : "register"])}
            </Button>
            <Button
              icon={<ClearOutlined />}
              onClick={clearSteps}
              disabled={!steps.length}
            >
              {i18n(dictionary.pages.admissionFlowCreate.tabs.t1.buttons.clear)}
            </Button>
            <Button onClick={() => navigate(Routes.ADMISSION_FLOW)}>
              {i18n(dictionary.pages.admissionFlowCreate.tabs.t1.buttons.cancel)}
            </Button>
          </Flex>
        </If>
      </Spin>
    </>
  );
}
